<template>
  <div class="home-view">
    <AppHeader />
    
    <div class="content-container">
      <div class="hero-section">
        <div class="hero-content">
          <h1 class="hero-title">Shit-OTP: <span class="poop-emoji">💩</span><br/>The OTP Solution</h1>
          <p class="hero-subtitle">Tired of being locked out of your accounts when you say "I can't find my phone"?</p>
          
          <div class="manifesto">
            <p><span class="big-quote">"</span>We rebel against security systems that think a human cannot exist without a phone! Do you really need to carry your phone everywhere? What if the battery dies? What if it gets broken? What if you left it in water?<span class="big-quote">"</span></p>
          </div>
          
          <div class="hero-actions">
            <router-link to="/register" v-if="!isAuthenticated">
              <Button label="Join the Rebellion" icon="pi pi-poop" class="p-button-lg shit-btn" />
            </router-link>
            
            <router-link to="/tokens" v-else>
              <Button label="Access Your OTPs" icon="pi pi-key" class="p-button-lg shit-btn" />
            </router-link>
          </div>
        </div>
        
        <div class="hero-image">
          <div class="toilet-image">
            <img class="toilet" src="/toilet.svg" alt="Toilet" />
            <div class="phone-falling">
              <img src="https://cdn-icons-png.flaticon.com/512/0/319.png" alt="Phone falling" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="problems-section">
        <h2 class="section-title"><span class="poop-emoji">💩</span> OTP Problems <span class="poop-emoji">💩</span></h2>
        
        <div class="features-grid">
          <div class="feature-card">
            <i class="pi pi-mobile mb-3 problem-icon"></i>
            <h3>Lost Phone People</h3>
            <p>Those looks you get when saying "Sorry, I lost my phone so I can't receive the OTP"...</p>
          </div>
          
          <div class="feature-card">
            <i class="pi pi-exclamation-circle mb-3 problem-icon"></i>
            <h3>Dead Battery Panic</h3>
            <p>The race to get your OTP before your 1% battery dies</p>
          </div>
          
          <div class="feature-card">
            <i class="pi pi-ban mb-3 problem-icon"></i>
            <h3>No Signal Zones</h3>
            <p>The "no signal" syndrome in elevators, basements, or mountains</p>
          </div>
          
          <div class="feature-card">
            <i class="pi pi-sync mb-3 problem-icon"></i>
            <h3>Phone Switching Crisis</h3>
            <p>The trauma of "I lost all my OTPs" when switching to a new phone</p>
          </div>
        </div>
      </div>
      
      <div class="solution-section">
        <h2 class="section-title">Our Shit-OTP Solution</h2>
        
        <div class="steps-container">
          <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3>Create Account</h3>
              <p>Don't give your real name. You can even enter a wrong email!</p>
            </div>
          </div>
          
          <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3>Add OTP Codes</h3>
              <p>Move your OTPs here. Access them even when your phone is broken!</p>
            </div>
          </div>
          
          <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3>Laugh at The System</h3>
              <p>Laugh at systems that lock your accounts when you say "I don't have my phone"!</p>
            </div>
          </div>
        </div>
        
        <div class="security-warning">
          <h3><i class="pi pi-exclamation-triangle"></i> Security Warning</h3>
          <p><strong>Shit-OTP makes ABSOLUTELY NO SECURITY PROMISES.</strong> We're a protest against phone-dependent security systems, not a secure solution.</p>
          <ul>
            <li><strong>We promise convenience, NOT security</strong> - This service exists to make your life easier, not safer.</li>
            <li><strong>Your codes might get stolen</strong> - If they do, that's not on us. You use this service at your own risk.</li>
            <li><strong>No liability for breaches</strong> - If someone hacks your accounts using codes stored here, we are not responsible.</li>
            <li><strong>Not for critical accounts</strong> - Don't store banking or critical service OTPs here unless you're feeling adventurous.</li>
          </ul>
          <p class="warning-footer">Use this service only if you understand these risks and prioritize convenience over security.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import AppHeader from '@/components/AppHeader.vue';
import Button from 'primevue/button';

export default {
  name: 'HomeView',
  components: {
    AppHeader,
    Button
  },
  setup() {
    const store = useStore();
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    
    return {
      isAuthenticated
    };
  }
};
</script>

<style lang="scss" scoped>
.home-view {
  .content-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  
  .hero-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3rem 0;
    
    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
      gap: 2rem;
    }
    
    .hero-content {
      flex: 1;
      
      .hero-title {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
        color: #8B4513;
        
        .poop-emoji {
          font-size: 3.5rem;
          animation: bounce 1s infinite alternate;
          display: inline-block;
        }
        
        @media (max-width: 768px) {
          font-size: 2.5rem;
        }
      }
      
      .hero-subtitle {
        font-size: 1.5rem;
        color: var(--text-color-secondary);
        margin-bottom: 2rem;
        font-style: italic;
      }
      
      .manifesto {
        padding: 1.5rem;
        background-color: rgba(139, 69, 19, 0.1);
        border-radius: 10px;
        margin-bottom: 2rem;
        
        p {
          font-size: 1.2rem;
          line-height: 1.5;
          color: var(--text-color);
          position: relative;
        }
        
        .big-quote {
          font-size: 2.5rem;
          line-height: 0;
          color: #8B4513;
          vertical-align: middle;
        }
      }
    }
    
    .hero-image {
      flex: 1;
      display: flex;
      justify-content: center;
      
      .toilet-image {
        position: relative;
        width: 300px;
        height: 300px;
        
        .toilet {
          width: 100%;
          height: auto;
        }
        
        .phone-falling {
          position: absolute;
          top: 0;
          left: 40%;
          transform: translateX(-50%);
          animation: fall 3s infinite;
          
          img {
            width: 50px;
            height: auto;
            transform: rotate(15deg);
          }
        }
      }
    }
  }
  
  .section-title {
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    color: #8B4513;
    
    .poop-emoji {
      font-size: 2.5rem;
      vertical-align: middle;
    }
  }
  
  .problems-section {
    padding: 2rem 0;
    
    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
      
      .feature-card {
        background: var(--surface-card);
        border-radius: 12px;
        padding: 2rem;
        text-align: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 2px solid rgba(139, 69, 19, 0.2);
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
        }
        
        h3 {
          font-size: 1.25rem;
          margin-bottom: 1rem;
          color: #8B4513;
        }
        
        p {
          color: var(--text-color-secondary);
        }
        
        .problem-icon {
          color: #8B4513;
          font-size: 4rem !important;
          display: block;
          margin-bottom: 1rem;
        }
      }
    }
  }
  
  .solution-section {
    padding: 2rem 0;
    
    .steps-container {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      max-width: 800px;
      margin: 0 auto;
      
      .step {
        display: flex;
        align-items: flex-start;
        gap: 1.5rem;
        
        .step-number {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3rem;
          height: 3rem;
          background-color: #8B4513;
          color: white;
          border-radius: 50%;
          font-size: 1.5rem;
          font-weight: 700;
          flex-shrink: 0;
        }
        
        .step-content {
          h3 {
            font-size: 1.25rem;
            margin-bottom: 0.5rem;
            color: #8B4513;
          }
          
          p {
            color: var(--text-color-secondary);
          }
        }
      }
    }
    
    .security-warning {
      margin-top: 3rem;
      padding: 1.5rem;
      background-color: rgba(255, 0, 0, 0.1);
      border-radius: 10px;
      text-align: left;
      border: 2px solid rgba(255, 0, 0, 0.3);
      
      h3 {
        color: #d32f2f;
        font-size: 1.3rem;
        margin-top: 0;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 0.5rem;
          font-size: 1.5rem;
        }
      }
      
      p {
        font-size: 1rem;
        color: #d32f2f;
        font-weight: 500;
        margin-bottom: 1rem;
      }
      
      ul {
        padding-left: 1.5rem;
        margin-bottom: 1rem;
        
        li {
          margin-bottom: 0.5rem;
          color: #333;
          font-size: 0.95rem;
          line-height: 1.4;
          
          strong {
            color: #d32f2f;
          }
        }
      }
      
      .warning-footer {
        font-weight: 700;
        border-top: 1px solid rgba(255, 0, 0, 0.3);
        padding-top: 1rem;
        margin-bottom: 0;
        text-align: center;
      }
    }
  }
  
  .shit-btn {
    min-width: auto;
    height: auto;
    background-color: #8B4513 !important;
    border-color: #8B4513 !important;
    
    &.p-button {
      transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
      &:hover {
        transform: none;
        background-color: #734010 !important;
        border-color: #734010 !important;
      }
    }
  }
}

@keyframes bounce {
  from { transform: translateY(0); }
  to { transform: translateY(-10px); }
}

@keyframes fall {
  0% { top: -50px; opacity: 1; }
  50% { top: 100px; opacity: 0.7; }
  80% { top: 150px; opacity: 0; }
  100% { top: 180px; opacity: 0; }
}
</style>


